"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
var _LineChart = require("@mui/x-charts/LineChart");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
/**
* Nom : GraphTachymeter.js
* Description : Ce fichier contient la définition du composant GraphTachymeter 
*               Ce composant affiche un graphique avec des courbes sur les données des tachymètres
* Date de création : 24 juillet 2025
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* GraphTachymeter : ce composant affiche un graphique avec des courbes sur les données des tachymètres
*
* Type : composant 
*
* Parametres : 
*  - data -- données des tachymètres
*/function GraphTachymeter(_ref) {
  var data = _ref.data;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LineChart.LineChart, {
      height: 300,
      series: [{
        data: data.map(function (item) {
          return item.rotor_1_speed;
        }),
        label: 'Vitesse rotor 1',
        shape: 'circle',
        showMark: true // obligatoire pour rendre les points
      }, {
        data: data.map(function (item) {
          return item.rotor_1_blocked === 1 ? item.rotor_1_speed : null;
        }),
        label: 'Failure rotor 1',
        showMark: true,
        shape: 'cross',
        color: 'orange'
      }, {
        data: data.map(function (item) {
          return item.rotor_2_speed;
        }),
        label: 'Vitesse rotor 2',
        shape: 'circle',
        showMark: true // obligatoire pour rendre les points
      }, {
        data: data.map(function (item) {
          return item.rotor_2_blocked === 1 ? item.rotor_2_speed : null;
        }),
        label: 'Failure rotor 2',
        showMark: true,
        shape: 'cross',
        color: 'orange'
      }, {
        data: data.map(function (item) {
          return item.command;
        }),
        label: 'Commande (%)',
        shape: 'circle',
        showMark: false,
        // obligatoire pour rendre les points
        color: 'none'
      }],
      xAxis: [{
        scaleType: 'point',
        data: data.map(function (item) {
          return item.datetime;
        })
      }],
      yAxis: [{
        min: 0,
        max: 5000
      }],
      margin: {
        right: 24
      }
    })
  });
}
var _default = exports["default"] = GraphTachymeter;